class AddExperienceController {
  /* @ngInject */
  constructor (skillsObj, $mdDialog, UsersService, prevJobInfo, user, edit, $mdToast) {
    this.$mdDialog = $mdDialog
    this.$mdToast = $mdToast
    this.user = user
    this.edit = edit
    this.UsersService = UsersService
    this.skillsObj = skillsObj
    this.prevJobInfo = prevJobInfo
    this.years = []
    let year = (new Date()).getFullYear()
    while (year >= 1999) {
      this.years.push(year.toString())
      year--
    }
  }

  showSkillsDialog (ev) {
    const parentEl = document.body
    this.$mdDialog.show({
      contentElement: '#skillsDialog',
      parent: parentEl,
      fullscreen: true,
      targetEvent: ev,
      multiple: true,
      clickOutsideToClose: true
    })
  }

  cancel () {
    this.$mdDialog.cancel()
  }

  submitExperience () {
    if (this.experienceSubmitted === true) {
      return
    }

    let date = this.prevJobInfo.end_year || null
    const skillsToSubmit = this.skillsObj
      .filter(skill => this.prevJobInfo.skills
      .includes(skill.name))
      .map(skill => skill.id)

    this.UsersService.addWorkHistoryRecord(
      this.user.internalId, this.prevJobInfo.company_name, this.prevJobInfo.title,
      skillsToSubmit, date, this.prevJobInfo.length
    )
    .then(() => {
      this.experienceSubmitted = true
      this.UsersService.getWorkHistory(this.user.internalId)
        .then((wh) => {
          this.prevJobInfo = {}
          this.prevJobInfo.skills = []
          this.$mdDialog.hide(wh)
        })
    }
    )
    .catch((err) => {
      this.experienceSubmitted = false
      this.$mdToast.showSimple(err.reason)
    })
  }

  editExperience () {
    if (this.experienceSubmitted === true) {
      return
    }

    const skillsToSubmit = this.skillsObj
      .filter(skill => this.prevJobInfo.skills
      .includes(skill.name))
      .map(skill => skill.id)
    let date = this.prevJobInfo.end_year || null
    this.UsersService.editWorkHistory(
      this.user.internalId, this.prevJobInfo.id, this.prevJobInfo.company_name, this.prevJobInfo.title,
      skillsToSubmit, date, this.prevJobInfo.length
    )
    .then(() => {
      this.experienceSubmitted = true
      this.UsersService.getWorkHistory(this.user.internalId)
        .then((wh) => {
          this.prevJobInfo = {}
          this.prevJobInfo.skills = []
          this.$mdDialog.hide(wh)
        })
    }
    )
    .catch((err) => {
      this.experienceSubmitted = false
      this.$mdToast.showSimple(err.reason)
    })
  }

  toggle (item) {
    var idx = this.prevJobInfo.skills.indexOf(item)
    if (idx > -1) {
      this.prevJobInfo.skills.splice(idx, 1)
    } else {
      this.prevJobInfo.skills.push(item)
    }
  }

  toggleChoice (item) {
    var idx = this.choices.indexOf(item)
    if (idx > -1) {
      this.choices.splice(idx, 1)
    } else {
      this.choices.push(item)
    }
  }

  exists (item) {
    return this.prevJobInfo.skills.indexOf(item) > -1
  }
}

export default AddExperienceController
